import React from "react";
import "./WelcomePage.scss";
import ResponsivePicture from "@components/ResponsivePicture/ResponsivePicture";
import PageSection from "@components/Page/PageSection";

import PageBannerMobile from "@/assets/images/welcome/375x465.jpg";
import PageBannerTablet from "@/assets/images/welcome/768x430.jpg";
import PageBannerDesktop from "@/assets/images/welcome/1024x425.jpg";
import PageBannerDefault from "@/assets/images/welcome/1440x610.jpg";
import PageBannerMax from "@/assets/images/welcome/1900x610.jpg";
import ContentBanner from "@/assets/images/welcome/content-banner.png";
import {useAuth} from "@msal/useAuth";
import {ChevronRightIcon} from "@components/Icons/ChevronRightIcon";
import Page from "@components/Page/Page";
import {usePublicTranslations} from "@i18n/i18nUtils";
import {useDismissOverlayOnMount} from "@commons/Hooks";
import {useNavigate} from "react-router-dom";
import {buildRoute} from "@router/RouterUtils";
import {AppRoute} from "@router/RoutingModels";
import {useAppContextStore} from "@store/AppContextStore";
import {useShallow} from "zustand/react/shallow";

export default function WelcomePage() {

    useDismissOverlayOnMount();

    const navigate = useNavigate();

    const {t} = usePublicTranslations();

    const {loginRedirect, isAuthenticated} = useAuth();

    const {status, statusReason} = useAppContextStore(useShallow(s => ({
        status: s.status,
        statusReason: s.statusReason,
    })));

    if (isAuthenticated && statusReason === null && (status === "ready" || status === "idle")) {
        navigate(buildRoute(AppRoute.HOME));
        return;
    }

    return (
        <>
            <Page>

                <div className="kv with-content">
                    <ResponsivePicture
                        alt="Gewiss Passion"
                        images={[
                            PageBannerMobile,
                            PageBannerTablet,
                            PageBannerDesktop,
                            PageBannerDefault,
                            PageBannerMax,
                        ]}
                    />
                    <div className="kv__content">
                        <div className="container">
                            <div className="kv__content__inner">
                                <h1 className={"tp-giga semibold"}>
                                    {t("public.welcome.title")}{" "}
                                    <span style={{display: "block"}}>Gewiss Passion</span>
                                </h1>

                                <h2 className={"tp-m light"}>
                                    {t("public.welcome.subtitle")}
                                </h2>

                                <div className={"kv__content__actions"}>
                                    <button onClick={() => loginRedirect("SIGNIN")} className={"cta cta--medium"}>
                                    <span className="label">
                                        {t("public.welcome.cta.login")}
                                    </span>
                                        <span className="icon">
                                        <ChevronRightIcon/>
                                    </span>
                                    </button>
                                    <button onClick={() => loginRedirect("SIGNUP")}
                                            className={"cta cta--secondary no-border cta--medium"}>
                                    <span className="label">
                                         {t("public.welcome.cta.signup")}
                                    </span>
                                        <span className="icon">
                                        <ChevronRightIcon/>
                                    </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="page__content">
                    <PageSection bg={"dark"}>

                        <div className="welcome-content">
                            <div className="welcome-content__content">
                                <h2 className={"tp-xl semibold"}>{t("public.welcome.howto.title")}</h2>
                                <p className={"tp-s"}>
                                    {t("public.welcome.howto.lead")}
                                    <br/>
                                    <br/>
                                    <strong>{t("public.welcome.howto.step1.title")}</strong><br/>
                                    {t("public.welcome.howto.step1.text")}
                                    <br/>
                                    <br/>
                                    <strong>{t("public.welcome.howto.step2.title")}</strong><br/>
                                    {t("public.welcome.howto.step2.text")}
                                    <br/>
                                    <br/>
                                    <strong>{t("public.welcome.howto.step3.title")}</strong><br/>
                                    {t("public.welcome.howto.step3.text")}
                                    <br/>
                                    <br/>
                                    <strong>{t("public.welcome.howto.step4.title")}</strong><br/>
                                    {t("public.welcome.howto.step4.text")}
                                </p>
                                <div className="welcome-content__actions">
                                    <button onClick={() => loginRedirect("SIGNIN")} className={"cta cta--medium"}>
                                    <span className="label">
                                         {t("public.welcome.cta.discover")}
                                    </span>
                                        <span className="icon">
                                        <ChevronRightIcon/>
                                    </span>
                                    </button>
                                </div>
                            </div>
                            <div className="welcome-content__media">
                                <img src={ContentBanner} alt=""/>
                            </div>
                        </div>

                    </PageSection>
                </div>

            </Page>

        </>
    );
}
